<template>
    <div class="about">
        <div style="min-height: 5.6rem;"></div>
        <section class="banner" data-aos="fade-up" data-aos-duration="1000">
            <img  class="hidden-xs-only" src="/imgs/about/guanyuaotian_banner.jpg" alt="" />
            <img  class="hidden-sm-and-up" src="/imgs/about/banner_f.png" alt="" />
            <div data-aos="slide-down" data-aos-duration="1000">
                <h1>傲天医疗</h1>
                <p>傲天的使命和目标是专注血液安全，守护生命健康</p>
                <P>发展成为医疗卫生智慧建设的领跑者。</P>
            </div>
        </section>

        <div class="space" id="jj"></div>
        <section class="atma"  data-aos="fade-up" data-aos-duration="1000">
            <div class="atma-title">
                <div class="title">
                    <span></span>
                    <h3>傲天医疗</h3>
                </div>
            </div>
            <div class="atma-content">
                <div class="">{{ content }}</div>
            </div>
            <div class="atma-imgs hidden-xs-only">
                <el-row :gutter="10">
                    <el-col :span="8">
                        <img  src="/imgs/about/qiyetu_a.png" alt="" />
                    </el-col>
                    <el-col :span="8">
                        <img  src="/imgs/about/qiyetu_b.png" alt="" />
                    </el-col>
                    <el-col :span="8">
                        <img  src="/imgs/about/qiyetu_c.png" alt="" />
                    </el-col>
                </el-row>
            </div>
            <div class="atma-imgs-xs hidden-sm-and-up">
                <img  src="/imgs/about/qiyetu_a.png" alt="" />
                <img  src="/imgs/about/qiyetu_b.png" alt="" />
                <img  src="/imgs/about/qiyetu_c.png" alt="" />
            </div>
        </section>

        <div class="space" id="wh"></div>
        <section class="culture" data-aos="fade-up" data-aos-duration="1000">
            <div class="culture-title">
                <div class="title">
                    <span></span>
                    <h3>企业文化</h3>
                </div>
            </div>
            <div class="culture-content">
                <div>
                    <ul>
                        <li>
                            <h4>使命</h4>
                            <p>专注血液安全，守护生命健康</p>
                        </li>
                        <li>
                            <h4>愿景</h4>
                            <p>傲天让血液更安全，生命更健康</p>
                        </li>
                        <li>
                            <h4>目标</h4>
                            <p>发展成为医疗卫生智慧化建设的领跑者</p>
                        </li>
                        <li>
                            <h4>价值观</h4>
                            <p>务实、创新、责任、共赢</p>
                        </li>
                        <li>
                            <h4>方针</h4>
                            <p>品质、安全、高效、标准 </p>
                        </li>
                    </ul>
                </div>
                <img  class="hidden-xs-only" src="/imgs/about/qiyewenhua.jpg" alt="">
                <img  class="hidden-sm-and-up" src="/imgs/about/shoujiduan_qiyewenhua.png" alt="">
            </div>
        </section>

        <div class="space" id="zz"></div>
        <section class="certification" data-aos="fade-up" data-aos-duration="1000">
            <div class="certification-title">
                <div class="title">
                    <span></span>
                    <h3>企业资质</h3>
                </div>
            </div>
            <div class="zz-img">
                <img  class="hidden-xs-only" src="/imgs/about/20220509102648.png" alt="">
                <img  class="hidden-sm-and-up" src="/imgs/about/sshoujiduan_qiyezizhi.png" alt="">
                <!-- <embed style="width:100vw;" src="/imgs/about/qiyezizhi.svg" type="image/svg+xml" pluginspage="http://www.adobe.com/svg/viewer/install"/> -->
            </div>
        </section>
        
        <div class="space" id="lc"></div>
        <section class="course" data-aos="fade-up" data-aos-duration="1000">
            <div class="course-title">
                <div class="title">
                    <span></span>
                    <h3>企业历程</h3>
                </div>
            </div>
            <div class="course-content-pc hidden-xs-only">
                <div class="course-left"><p></p></div>
                <div class="course-mid">
                    <span @click="handleArrow('left')"><i class="el-icon-arrow-left"></i></span>
                    <div class="course-list">
                        <div :style="'left:-'+courseIdx*15.27+'rem;'">
                            <div v-for="(item,idx) of course" :key="'course'+idx">
                                <span></span>
                                <h3>{{item.title}}</h3>
                                <div>
                                    {{item.description}}
                                </div>
                            </div>
                        </div>
                        <p></p>
                    </div>
                    <span @click="handleArrow('right')"><i class="el-icon-arrow-right"></i></span>
                </div>
                <div class="course-right"><p></p></div>
                <img  src="/imgs/about/qiyefazhanlicheng.jpg" alt="">
            </div>
            <div class="course-content-mobile hidden-sm-and-up">
                <div class="course-left">
                    <p></p>
                    <span @click="handleArrowMobile('left')"><i class="el-icon-arrow-left"></i></span>
                </div>
                <div class="course-mid">
                    <div class="course-list">
                        <div :style="'left:-'+courseIdx*250+'px;'">
                            <div v-for="(item,idx) of course" :key="'course'+idx">
                                <span></span>
                                <h3>{{item.title}}</h3>
                                <div>
                                    {{item.description}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <p></p>
                </div>
                <div class="course-right">
                    <span @click="handleArrowMobile('right')"><i class="el-icon-arrow-right"></i></span>
                    <p></p>
                </div>
                <img  src="/imgs/about/shoujiduan_qiyelicheng.png" alt="">
            </div>
        </section>
    </div>
</template>
<script>
import { 
    getCompanyIntroduction,
    getCompanyHistorys
} from '@/utils/api.js'
export default {
    name: "Home",
    components: {},
    data() {
        return {
            content:"    傲天医疗成立于2012年，致力于构建全球化公共卫生领域血液安全生态链，目前推出的有保障血液安全的智慧采血管理系统，冷链监控管理系统和实验室标本管理系统等系列全流程智能化产品，成为了安全可靠，值得信赖的公共卫生血液安全领域整体解决方案供应商，获得用户的一致好评。\n\n    公司坚持完善创新体系，拥有强大的研发团队，汇集了行业内精英骨干人才及归国留学研发人员，为打造成公共卫生血液安全产品专业供应商奠定了坚实的基础，公司先后被评为深圳市高新技术企业、国家级高新技术企业、深圳市科技创新委员会重点资助扶持企业、中国输血协会会员、广东省守合同重信用企业等。截止到2020年，公司共获得50多项计算机软件著作权登记证书和自主研发的实用新型专利证书。\n\n    坚持科学管理，完善质量管理体系。傲天医疗通过了ISO9000认证和GMP认证，建立了以深圳为中心，全国覆盖的质量服务体系，并重点引进国外先进生产装备，加强技术改造，提高工艺水平，促进产品提档升级，有效地保证了公司产品和服务的质量和效率，最大限度地保障了客户利益。",
            course:[],
            courseIdx:0,
        };
    },
    methods: {
        handleArrow(e){
            if(e=='left'){
                if(this.courseIdx>0){
                    this.courseIdx -= 1
                }
            }else{
                const courseLen = (this.course.length-4)>0?this.course.length-4:0
                console.log("courseLen",courseLen)
                if(this.courseIdx<courseLen){
                    this.courseIdx += 1
                    console.log("this.courseIdx",this.courseIdx)
                }
            }
        },
        handleArrowMobile(e){
            if(e=='left'){
                if(this.courseIdx>0){
                    this.courseIdx -= 1
                }
            }else{
                if(this.courseIdx < this.course.length-1){
                    this.courseIdx += 1
                }
            }
        },
        getData(){
            let req=0
            getCompanyIntroduction().then(res=>{
                if(res.data.code == 10000){
                    const data = res.data.data
                    this.content = data.content
                }
                req+=1
                if(req==2){
                    this.$nextTick(()=>{
                        if(this.$route.query&&this.$route.query.id){
                            const id=this.$route.query.id
                            // document.getElementById(id).scrollIntoView({behavior: "smooth", block: "start",})
                            let offsetTop = document.getElementById(id).offsetTop
                            // if(id=='lc'){
                            //     offsetTop +=document.querySelector('.zz-img').clientHeight
                            // }
                            document.body.scrollTop = offsetTop
                            document.documentElement.scrollTop = offsetTop
                        }
                    })
                }
            })
            getCompanyHistorys().then(res=>{
                if(res.data.code == 10000){
                    const data = res.data.data
                    this.course = data 
                }
                req+=1
                if(req==2){
                    this.$nextTick(()=>{
                        if(this.$route.query&&this.$route.query.id){
                            const id=this.$route.query.id
                            // document.getElementById(id).scrollIntoView({behavior: "smooth", block: "start",})
                            let offsetTop = document.getElementById(id).offsetTop
                            // if(id=='lc'){
                            //     offsetTop +=document.querySelector('.zz-img').clientHeight
                            // }
                            document.body.scrollTop = offsetTop
                            document.documentElement.scrollTop = offsetTop
                        }
                    })
                }
            })
        },
    },
    created() {
        document.title = "深圳市傲天医疗智能系统有限公司-关于傲天"
    },
    mounted() {
        this.getData()
        
    },
    
};
</script>
<style lang="less" scoped>
.about {
    padding-bottom: 7.7rem;
    position: relative;

    .banner {
        width: 100vw;
        position: relative;
        min-height: 25.8rem;
        img {
            width: calc(100vw + 25px);
            min-height: 25.8rem;
            position: relative;
            z-index: 1;
            object-fit: cover;
        }
        > div {
            width: 100vw;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 2;
            display: flex;
            flex-direction: column;
            align-items: center;
            color: #fff;
            > h1 {
                font-size: 2.5rem;
                margin: 10vh 0 2rem;
            }
            > p {
                width: 25rem;
                max-width: 80vw;
                text-align: center;
                font-size: 1.1rem;
                line-height: 1.6rem;
                margin: 0;
            }
        }
    }
    .title {
        display: flex;
        flex-direction: column;
        align-items: center;
        > h3 {
            margin: 0;
            font-size: 2.6rem;
        }
        > span {
            display: block;
            width: 5.6rem;
            height: 0.4rem;
            background: #0f45f9;
            margin-bottom: 1rem;
        }
    }
    .atma {
        width: 67rem;
        max-width: calc(100vw - 40px);
        margin:  0 auto ;
        position: relative;
        .atma-title {
            margin-bottom: 3.3rem;
        }
        .atma-content {
            color: #666666;
            margin:  0 2rem;
            > div {
                white-space: pre-wrap;
                font-size: 0.88rem;
                line-height: 1.6rem;
            }
        }
        .atma-imgs {
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        .atma-imgs-xs {
            width: 67rem;
            max-width: calc(100vw - 40px);
            margin:  20px auto ;
            overflow: hidden;
        }
    }
    .culture{
        position: relative;
        .culture-title {
            margin-bottom: 3.3rem;
        }
        .culture-content{
            position: relative;
            >div{
                width: 67rem;
                margin: 0 auto;
                position: relative;
                z-index: 2;
                display: flex;
                align-items: center;
                min-height: 40rem;
                ul{
                    color: #666666;
                    margin-top: -3rem;
                    li{
                        margin-bottom: 3rem;
                    }
                    h4{
                        font-size: 1.1rem;
                        margin:0;
                        margin-bottom: 0.5rem;
                    }
                    p{
                        margin: 0;
                        line-height: 1.6rem;
                        font-size: 0.88rem;
                        max-width: 80vw;
                    }
                }
            }
            >img{
                position: absolute;
                left: 0;
                top: 0;
                z-index: 1;
                width: 100vw;
                min-height: 40rem;
                object-fit: cover;
            }
            
        }
    }
    .certification{
        position: relative;
        .certification-title{
            margin-bottom: 3.3rem;
        }
        img{
            width: 100vw;
            object-fit: contain;
        }
    }
    .course{
        position: relative;
        .course-title{
            margin-bottom: 3.3rem;
        }
        .course-content-pc{
            position: relative;
            width: 100%;
            height: 35rem;
            display: flex;
            align-items: center;
            >img{
                position: absolute;
                width: 100vw;
                height: 35rem;
                left: 0;
                top: 0;
                z-index: 1;
                object-fit: cover;
            }
            .course-mid{
                width: 66.67rem;
                height:35rem;
                margin: 0 auto; 
                display: flex;
                align-items: center;
                position: relative;
                justify-content: space-between;
                .course-list{
                    position: relative;
                    z-index: 2;
                    display: flex;
                    color: #fff;
                    width: 61rem;
                    height:35rem;
                    margin: 0 auto;
                    overflow: hidden;
                    align-items: center;
                    z-index: 3;
                    >div{
                        display: flex;
                        align-items: center;
                        position: absolute;
                        overflow: hidden;
                        height: 35rem;
                        transition: all 0.3s ease;
                        left:0;
                        >div{
                            display: flex;
                            width: 13.27rem;
                            padding: 0 1rem;
                            min-width: 13.27rem;
                            height: 35rem;
                            z-index: 3;
                            >span{
                                display: block;
                                width: 14px;
                                height: 14px;
                                min-height: 14px;
                                min-width: 14px;
                                box-sizing: border-box;
                                border:3px solid #dfff;
                                background: #0C36EB;
                                border-radius: 50%;
                            }
                            >h3{
                                font-size: 1.3rem;
                            }
                            >div{
                                white-space: pre-wrap;
                                font-size: 0.88rem;
                            }
                            &:nth-child(even){
                                flex-direction: column;
                                >span{
                                    margin-top:17.1rem;
                                }
                            }
                            &:nth-child(odd){
                                flex-direction: column-reverse;
                                >span{
                                    margin-bottom:17.1rem;
                                }
                            }
                        }
                    }
                    >p{
                        margin: 0;
                        padding: 0;
                        width: 100%;
                        height: 1px ;
                        background: #fff;
                        position: absolute;
                        left: 0;
                        z-index: 2;
                    }
                }
                >span{
                    display: block;
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    box-sizing: border-box;
                    border:1px solid #fff;
                    color: #fff;
                    position: relative;
                    z-index: 3;
                    text-align: center;
                    line-height: 50px;
                    font-size: 20px;
                    cursor: pointer;
                    &:hover{
                        background: #fff;
                        color: #666666;
                    }
                }
            }
            .course-right,.course-left{
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                >p{
                    margin: 0;
                    padding: 0;
                    width: 100%;
                    height: 1px ;
                    background: #fff;
                    z-index: 2;
                }
            }
        }
        .course-content-mobile{
            position: relative;
            width: 100vw;
            height: 35rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            >img{
                position: absolute;
                width: 100vw;
                // height: 35rem;
                left: 0;
                top: 0;
                z-index: 1;
                object-fit: contain;
            }
            .course-mid{
                width: calc(100vw - 120px);
                height:35rem;
                display: flex;
                align-items: center;
                flex-direction: column;
                justify-content: center;
                position: relative;
                overflow: hidden;
                .course-list{
                    position: relative;
                    z-index: 3;
                    display: flex;
                    align-items: center;
                    color: #fff;
                    width: 250px;
                    height:35rem;
                    overflow: hidden;
                    >div{
                        display: flex;
                        align-items: center;
                        position: absolute;
                        overflow: hidden;
                        height: 35rem;
                        transition: all 0.3s ease;
                        left:0;
                        >div{
                            display: flex;
                            width: 250px;
                            height: 35rem;
                            >span{
                                display: block;
                                width: 14px;
                                height: 14px;
                                min-height: 14px;
                                min-width: 14px;
                                box-sizing: border-box;
                                border:3px solid #dfff;
                                background: #0C36EB;
                                border-radius: 50%;
                            }
                            >h3{
                                font-size: 1.3rem;
                                margin: 0.8rem 0;
                            }
                            >div{
                                white-space: pre-wrap;
                                font-size: 0.88rem;
                            }
                            &:nth-child(even){
                                flex-direction: column;
                                >span{
                                    margin-top:17.1rem;
                                }
                            }
                            &:nth-child(odd){
                                flex-direction: column-reverse;
                                >span{
                                    margin-bottom:17.1rem;
                                }
                            }
                        }
                    }
                }
                >p{
                    margin: 0;
                    padding: 0;
                    width: calc(100vw- 120px);
                    width: 100%;
                    height: 1px ;
                    background: #fff;
                    position: absolute;
                    left: 0;
                    z-index: 2;
                }
                
            }
            .course-right,.course-left{
                width: 60px;
                height: 100%;
                display: flex;
                align-items: center;
                >p{
                    margin: 0;
                    padding: 0;
                    width: 20px;
                    height: 1px ;
                    background: #fff;
                    z-index: 2;
                }
                >span{
                    display: block;
                    width: 40px;
                    height: 40px;
                    min-width: 40px;
                    min-height: 40px;
                    border-radius: 50%;
                    box-sizing: border-box;
                    border:1px solid #fff;
                    color: #fff;
                    position: relative;
                    z-index: 3;
                    text-align: center;
                    line-height: 40px;
                    font-size: 20px;
                    cursor: pointer;
                    &:hover{
                        background: #fff;
                        color: #666666;
                    }
                    -webkit-tap-highlight-color: rgba(0,0,0,0);/*CSS3去除手机浏览器按钮点击出现的高亮框*/
                    -webkit-tap-highlight-color: transparent;
                    -moz-tap-highlight-color: transparent;
                }
            }
        }
    }
    .space{
        min-height: 7.7rem;
        width: 100%;
    }
}
</style>
